import React from "react";
import style from "./Features.module.css";
import Markdown from 'markdown-to-jsx';

export default function Features({ features }) {
  return (
    <div className={style.root}>
      <div className={style.inner}>
        <h2>Features</h2>
        <div className="std"><Markdown>{features}</Markdown></div>
      </div>
    </div>
  );
}
